const BASE = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

export async function submitAnalysis(videoFile, pdfFile) {
  const form = new FormData();
  form.append("video", videoFile);
  form.append("rules", pdfFile);
  const res = await fetch(`${BASE}/analyze`, { method: "POST", body: form });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getJob(jobId) {
  const res = await fetch(`${BASE}/jobs/${jobId}`);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function downloadReport(jobId) {
  const res = await fetch(`${BASE}/files/report/${jobId}`);
  if (!res.ok) throw new Error("Report not ready");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `violation_report_${jobId}.md`;  // Downloads as .md file
  a.click();
  URL.revokeObjectURL(url);
}

// Optional: View report in browser
export async function viewReport(jobId) {
  window.open(`${BASE}/files/report/${jobId}/view`, '_blank');
}

export async function generateVideo() {
  const res = await fetch(`${BASE}/files/video/generate`);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export const getVideoUrl = (jobId) => `${BASE}/files/video/${jobId}`;

export async function checkHealth() {
  try {
    const res = await fetch(`${BASE}/health`);
    return res.ok;
  } catch { return false; }
}

export function pollJob(jobId, onTick, intervalMs = 2500) {
  return new Promise((resolve, reject) => {
    const timer = setInterval(async () => {
      try {
        const job = await getJob(jobId);
        onTick(job);
        if (job.status === "completed" || job.status === "failed") {
          clearInterval(timer);
          resolve(job);
        }
      } catch (err) {
        clearInterval(timer);
        reject(err);
      }
    }, intervalMs);
  });
}